var offsetX = 0;
var offsetY = 0;
var width = 50;
var height = 70;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var titleFontSize = 5.6;
var titleWidth = width - marginX * 2;
var titleHeight = 7.4;
var contentWidth = width - marginX * 3;
var contentHeight = 4.3;
var sheetHeight = 6.0;
var fontSize = 3;
var qrCodeHeight = height - marginY * 20;
var qrCodeWidth = qrCodeHeight;
//批量打印数据
export const batchPrintPhoneData = {
  data: [
    {
      InitDrawingBoardParam: {
        "width": width,
        "height": height,
        "rotate": rotate,
        "path": "ZT001.ttf",
        "verticalShift": 0,
        "HorizontalShift": 0
    },

    "elements": [
        {
            type: 'text',
            json: {
                "x": marginX + offsetX,
                "y": marginY * 2 + offsetY,
                "height": titleHeight,
                "width": titleWidth,
                "value": "新机出入库标签",
                "fontFamily": "宋体",
                "rotate": 0,
                "fontSize": titleFontSize,
                "textAlignHorizonral": 1,
                "textAlignVertical": 1,
                "letterSpacing": 0.0,
                "lineSpacing": 1.0,
                "lineMode": 6,
                "fontStyle": [true, false, false, false],
            }
        },

        {
            type: 'text',
            json: {
                "x": marginX * 1.5 + offsetX,
                "y": marginY * 6.5 + offsetY,
                "height": contentHeight,
                "width": contentWidth,
                "value": "手机品牌：苹果",
                "fontFamily": "宋体",
                "rotate": 0,
                "fontSize": fontSize,
                "textAlignHorizonral": 0,
                "textAlignVertical": 1,
                "letterSpacing": 0.0,
                "lineSpacing": 1.0,
                "lineMode": 6,
                "fontStyle": [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                "x": marginX * 1.5 + offsetX,
                "y": marginY * 6.5+sheetHeight + offsetY,
                "height": contentHeight,
                "width": contentWidth,
                "value": "机型名称：iPhone 18 Pro",
                "fontFamily": "宋体",
                "rotate": 0,
                "fontSize": fontSize,
                "textAlignHorizonral": 0,
                "textAlignVertical": 1,
                "letterSpacing": 0.0,
                "lineSpacing": 1.0,
                "lineMode": 6,
                "fontStyle": [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                "x": marginX * 1.5 + offsetX,
                "y": marginY * 6.5+sheetHeight*2  + offsetY,
                "height": contentHeight,
                "width": contentWidth,
                "value": "内存：512G",
                "fontFamily": "宋体",
                "rotate": 0,
                "fontSize": fontSize,
                "textAlignHorizonral": 0,
                "textAlignVertical": 1,
                "letterSpacing": 0.0,
                "lineSpacing": 1.0,
                "lineMode": 6,
                "fontStyle": [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                "x": marginX * 1.5 + offsetX,
                "y": marginY * 6.5+sheetHeight*3 + offsetY,
                "height": contentHeight,
                "width": contentWidth,
                "value": "颜色：远峰蓝",
                "fontFamily": "宋体",
                "rotate": 0,
                "fontSize": fontSize,
                "textAlignHorizonral": 0,
                "textAlignVertical": 1,
                "letterSpacing": 0.0,
                "lineSpacing": 1.0,
                "lineMode": 6,
                "fontStyle": [false, false, false, false],
            }
        },
        {
            type: "qrCode",
            json: {
              x: marginX * 1.5 + offsetX,
              y: marginY * 6.5 + sheetHeight * 4 + offsetY,
              height: qrCodeHeight,
              width: qrCodeWidth,
              value: "10000000",
              codeType: 31,
              rotate: 0,
              fontSize: fontSize,
              textHeight: fontSize,
              textPosition: 0,
            }
        }
    ]
    }
  ],
};



// WEBPACK FOOTER //
// ./src/utils/printData/newPhone.js